import { Builder } from '@builder.io/react'
import React from 'react'

interface Props {
  backgroundColor: string
  imageBackgroundColor: string
  height: string
  isHeroSkeleton: boolean
}

const SkeletonImage = ({ backgroundColor, imageBackgroundColor, height, isHeroSkeleton }: Props) => {
  return (
    <div
      role="status"
      className={`space-y-8 md:space-y-0 md:space-x-8 md:flex md:items-center justify-center w-full ${isHeroSkeleton ? 'lg:-mt-12' : ''} h-[${height}]`}
      style={{ backgroundColor: backgroundColor }}
    >
      <div
        className="flex items-center justify-center w-10/12 mx-auto h-48 bg-gray-300 rounded sm:w-96 animate-pulse m-8 mt-20"
        style={{ backgroundColor: imageBackgroundColor }}
      >
        <svg
          className="w-10 h-10 text-gray-300"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 18"
        >
          <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
        </svg>
      </div>
    </div>
  )
}
export default SkeletonImage

Builder.registerComponent(SkeletonImage, {
  name: 'SkeletonImage',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: '#f9f5f1'
    },
    {
      name: 'imageBackgroundColor',
      type: 'color',
      defaultValue: '#e0e0e0'
    },
    {
      name: 'height',
      type: 'string',
      defaultValue: '14rem'
    },
    {
      name: 'isHeroSkeleton',
      type: 'boolean',
      defaultValue: false
    }
  ]
})
